import { Direction } from "@app/models/direction.model";

export interface IGood {
  goodId?: string | null
  supplyId?: string | null
  mnnId?: number | null
  mnnName?: string | null
  tradeName?: string | null
  lovId?: number | null
  dosage?: string | null
  unit?: string | null
  releaseForm?: string | null
  quantity?: number | null
  unitPrice?: number | null
  totalPrice?: number | null
  direction?: Direction | null
  subDirection?: string | null
}

export class Good implements IGood {

  constructor(model?: Partial<IGood>) {
    if (model) {
      Object.assign(this, model);
    }
  }

  goodId?: string | null;
  supplyId?: string | null;
  mnnId?: number | null;
  mnnName?: string | null;
  tradeName?: string | null;
  lovId?: number | null;
  dosage?: string | null;
  unit?: string | null;
  releaseForm?: string | null;
  quantity?: number | null;
  unitPrice?: number | null;
  totalPrice?: number | null;
  direction?: Direction | null;
  subDirection?: string | null;
}
